import { store } from '@redux/store';
import { fromEvent, map, filter } from 'rxjs';
import LoadingStatus from 'enums/loadingStatus';
import { selectLoading, selectConfigurationImageResizeService } from 'layout/redux/selectors';
import generateRandomNumber from 'utils/randomNumber';

/**
 * Generates a random number and returns a URL string for a lifestyle image based on that number.
 * @param imageResizeService - is a string representing the domain Image Resize Service.
 * @returns a string that represents the URL of a randomly selected lifestyle image.
 */
const getLifeStyleImage = (imageResizeService) => {
  const randomNumber = generateRandomNumber(1, 20);
  return `${imageResizeService}/images/Lifestyle/lifestyle_${randomNumber}.jpg`;
};

/**
 * Removes all `<source>` elements within the closest `<picture>` element of a given image.
 * @param image - is a reference to an HTML `img` element.
 */
const removeSource = (image) => {
  const picture = image.closest('picture');
  if (picture) {
    picture.querySelectorAll('source').forEach((element) => element.remove());
  }
};

/**
 * Replaces the source of an image element with a placeholder image if the original image fails to load.
 * @param image - is the HTML `img` element that needs to be replaced with a new image source in case of an error.
 * @param selectResourcesHostNames - is an object that contains the IRS and resource domain URLs.
 */
const onErrorImage = (image) => {
  const state = store.getState();
  if(selectLoading(state) === LoadingStatus.Succeeded.toString()){
    const imageResizeService = selectConfigurationImageResizeService(state);
    removeSource(image);
    const imageSrc = getLifeStyleImage(imageResizeService);
        
    image.src = imageSrc;
    image.onerror = null;
  }
};

/**
 * handlerErrorImages: active an observer when any image dispatch the on error event
 */
const handlerErrorImages = function (container) {
  if(container){
    const errorObservable = fromEvent(container, 'error', true).pipe(
      filter(event => event.target.dataset.cardElement === 'image'),
      map((event) => event.target)
    );
    errorObservable.subscribe(onErrorImage);
  }  
};

export default handlerErrorImages;
